import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const OrgQRCode = ({ orgPin, onQRGenerated }) => {
	const [qrCodeUrl, setQrCodeUrl] = useState('');

	useEffect(() => {
		generateQRCode();
	}, [orgPin]);

	const generateQRCode = async () => {
		try {
			const httpsDeepLink = `https://assemblie.app/pinauth?orgPin=${orgPin}`;
			const qrCodeDataUrl = await QRCode.toDataURL(httpsDeepLink, {
				width: 200,
				margin: 2,
				color: {
					dark: '#000000',
					light: '#ffffff',
				},
			});
			setQrCodeUrl(qrCodeDataUrl);
			onQRGenerated(qrCodeDataUrl);
		} catch (err) {
			console.error('Error generating QR code:', err);
		}
	};

	return (
		<div className='qr-code'>
			{qrCodeUrl && (
				<img
					src={qrCodeUrl}
					alt='Organization QR Code'
					style={{ width: 200, height: 200 }}
				/>
			)}
		</div>
	);
};

export default OrgQRCode;
